'use client';

import { useQuery } from '@tanstack/react-query';
import { useWallet } from './use-wallet';

export interface FlaunchPosition {
  flaunchAddress: string;
  tokenId: number;
  name: string;
  symbol: string;
  imageUrl: string | null;
  memecoinAddress: string;
  liquidityUsd: number | null;
}

async function fetchPositions(address: string): Promise<FlaunchPosition[]> {
  const res = await fetch(`/api/flaunch-positions/${address}`);
  if (!res.ok) throw new Error('Failed to fetch Flaunch positions');
  return res.json();
}

export function useFlaunchPositions(active = true) {
  const { isConnected, address } = useWallet();

  const {
    data: positions = [],
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['flaunch-positions', address?.toLowerCase() ?? null],
    queryFn: () => fetchPositions(address!),
    enabled: active && isConnected && !!address,
    // Treat data as stale immediately so re-mounting the picker (e.g.
    // after a fresh launch) re-runs the query instead of silently using
    // a cached empty list. The 60s background refetch keeps the panel
    // live while it stays open.
    staleTime: 0,
    refetchInterval: active ? 60_000 : false,
  });

  return { positions, isLoading, isFetching, error, refetch };
}
